import { render, staticRenderFns } from "./ValorDoRebanhoMedioPorCategoriaAnimalPercentual.vue?vue&type=template&id=0df128d4&scoped=true&"
import script from "./ValorDoRebanhoMedioPorCategoriaAnimalPercentual.vue?vue&type=script&lang=js&"
export * from "./ValorDoRebanhoMedioPorCategoriaAnimalPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df128d4",
  null
  
)

export default component.exports